import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  showUpdateMinesProviderConfigForm: false,
  showCancelUpdateMinesProviderConfigForm: false,
  selectedMinesProviderConfig: {},
};

const updateMinesProviderConfigSlice = createSlice({
  name: 'updateMinesProviderConfig',
  initialState,
  reducers: {
    setShowUpdateMinesProviderConfigForm: (state, { payload }) => {
      state.showUpdateMinesProviderConfigForm = payload;
    },
    setShowCancelUpdateMinesProviderConfigForm: (state, { payload }) => {
      state.showCancelUpdateMinesProviderConfigForm = payload;
    },
    setSelectedMinesProviderConfig: (state, { payload }) => {
      state.selectedMinesProviderConfig = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: updateMinesProviderConfigReducer } = updateMinesProviderConfigSlice;
export const {
  setShowUpdateMinesProviderConfigForm,
  setShowCancelUpdateMinesProviderConfigForm,
  setSelectedMinesProviderConfig,
} = updateMinesProviderConfigSlice.actions;
